<form #form="ngForm" class="campanha-pedido-liberar" novalidate>
    <div class="campanha-pedido-liberar-header">       
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label" for="campanhaPedidoLiberarJustificativa">Justificativa</label>
                <textarea class="form-control" [(ngModel)]="req.justificativaLiberado" name="justificativaLiberado" id="justificativaLiberado" 
                    #justificativaLiberado="ngModel" #justificativaTextArea rows="3" placeholder="Informe a justificativa da liberação do(s) pedido(s)" required="required" minlength="15">
                </textarea>
                <p class="form-text text-muted">Informe uma justificativa explicando o porquê você está liberando este(s) pedido(s)</p>
                <sgt-form-control-error
                    *ngIf="justificativaLiberado.errors && justificativaLiberado.errors.required && justificativaLiberado.dirty"
                    msgError="A justificativa é obrigatória">
                </sgt-form-control-error>
                <sgt-form-control-error
                    *ngIf="justificativaLiberado.errors && justificativaLiberado.errors.minlength"
                    msgError="A justificativa deve ter no mínimo 15 caracteres">
                </sgt-form-control-error>                
            </div>
        </div>
    </div>
    
    <div class="campanha-pedido-liberar-body">
         <sgt-campanha-pedido-nao-liberado-view
            #pedidosNaoLiberadosView
            [idCampanha]="idCampanha"
            [filter]="filter"
            (afterLiberarPedido)="afterLiberarPedido.emit()">
         </sgt-campanha-pedido-nao-liberado-view>
    </div>
</form>